// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserTypes } from '../../interfaces/user.interfaces';
import { ErrorService } from '../../services/error.service';
import { AuthService } from '../services/auth.service';
import { LoginService } from '../services/login.service';
import { from } from 'rxjs';

@Component({
    selector: 'app-get-started',
    templateUrl: './get-started.component.html',
    styles: [
        `
            h2 {
                color: var(--white);
                text-align: center;
            }
        `,
    ],
})
export class GetStartedComponent {
    constructor(
        private readonly activatedRoute: ActivatedRoute,
        private readonly authService: AuthService,
        private readonly errorService: ErrorService,
        private readonly loginService: LoginService,
        private readonly router: Router
    ) {
        this.activatedRoute.params.subscribe((params) => {
            if ('email' in params && 'password' in params) {
                this.loginService.setTempPassword(params.password);
                this.authService.authenticateUser(
                    params.email,
                    params.password,
                    (auth) => {
                        const user = auth.user;
                        if (user) {
                            // FIXME: this should work with customers as well, but at this point in the flow, the customer's dealerId is -1, which is always "terminated" as it's not real
                            if (UserTypes.Dealer == user.userType && auth.isDealershipTerminated && !auth.hasOtherDealershipsAvailable) {
                                from(this.loginService.showTerminatedDealershipDialog()).subscribe((dialog) => {
                                    dialog.afterClosed().subscribe(() => router.navigate(['/login']));
                                });
                            } else if (!user.needToAcceptSystemDocument && !user.needProfileUpdate) {
                                //we know the user has already been set up
                                this.router.navigate(['/login']);
                            } else {
                                this.loginService.setUsername(user.logonId);
                                this.router.navigate(['/login', 'new-password']);
                            }
                        } else {
                            this.errorService.showError({
                                statusCode: 500,
                                message:
                                    'Please check your email and / or password to ensure you have entered them correctly. If you have forgotten your password, close this window and click on Reset Password to create a new one. If you cannot remember your email address, contact the dealership.',
                                title: 'Login Attempt Unsuccessful',
                            });
                        }
                    },
                    () => {
                        // invalid password (likely an expired welcome link)
                        this.router.navigate(['/login']);
                    },
                    () => this.router.navigate(['/login', 'two-factor-auth', 'verify']),
                    null,
                    true
                );
            }
        });
    }
}
